import { dataUpgrade } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUpgrade = /*#__PURE__*/createIcon(dataUpgrade)
export default IconUpgrade
